/*
    Title: Font Awesome Plugin
    Description: Allows Vue to display Font Awesome Icons
    Author: James Kingsthaite
*/

// Imports Dependencies
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Registers Font-Awesome Icons as a valid HTML element
library.add(fas);
library.add(fab);
library.add(far);
Vue.component('font-awesome-icon', FontAwesomeIcon);